import { faBell, faToolbox } from "@elynx/free-solid-svg-icons";
import { faTableTree } from "@elynx/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArticleOutlined, Person, Receipt } from "@mui/icons-material";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import i18n from "../../services/localization-service/i18n";
import { IRoute } from "../../routes/routes";
import { IKeyValuePair } from "../../common/models/KeyValuePair";

import type { JSX } from "react";

export type AdministrationListItemHeader = {
    title: string,
    icon: JSX.Element;
};


export type GroupedViewIDType = {
    [key: number]: IRoute[]
}


const AdministrationListUtils = {

    getHeaderInfo: function (viewID: UIViewEnum): AdministrationListItemHeader | undefined {

        switch (viewID) {
            case UIViewEnum.ObjectAdmin:
                return {
                    title: i18n.t('views.objectAdministration'),
                    icon: <FontAwesomeIcon icon={faToolbox} size="lg" />
                };

            //case UIViewEnum.AuditReporting:
            case UIViewEnum.AdminMiscellaneous:
                return {
                    title: i18n.t('views.miscellaneous'),
                    icon: <ArticleOutlined />,
                };

            case UIViewEnum.GroupAdmin:
                return {
                    title: i18n.t('views.groupAdministration'),
                    icon: <FontAwesomeIcon icon={faTableTree} size="lg" />,
                };

            case UIViewEnum.AdminAccounting:
                return {
                    title: i18n.t('views.accounting'),
                    icon: <Receipt />,
                };
    

            case UIViewEnum.UsersAndSecurity:
                return {
                    title: i18n.t('views.usersAndSecurity'),
                    icon: <Person />,
                };

            case UIViewEnum.AlarmsAndNotification_SetPointAdmin:
            return {
                title: i18n.t('views.alarmsAndNotifications'),
                icon: <FontAwesomeIcon icon={faBell} size="lg" />
            }

            default:
                break;
        }

    },
    groupByViewID: function(routes: IRoute[]): IKeyValuePair<number, IRoute[]>[] {

        const data = routes.reduce((result: IKeyValuePair<number, IRoute[]>[], o) => {

            const { groupingViewID, parentViewID } = o;
            const vid = (groupingViewID ?? parentViewID) as number;

            const item = result.find(v =>  v.Key === vid);

            if (item === undefined) {
                result.push({
                    Key: vid,
                    Value: [o]
                });
            } else {
                item.Value.push(o);
            }

            return result;
          },
          []);

        return data;
    }

};

export default AdministrationListUtils;
